import { assignByDomainMap } from '@/pages/RolloutTab/RolloutEditor/RolloutBlock/constants';

export const getDomainAssignBy = (domain: string) => {
  return assignByDomainMap?.[domain] || 'pax';
};
